import api from 'api/apiClient';
import { ensureFileId } from 'modules/shared/service';
import { formatDate } from 'modules/shared/utils';
import { API_VOUCHER_STATUS_KEYS, VOUCHER_STATUS_KEYS } from '../constants';

const unwrap = async (promise) => {
  const res = await promise;
  return res.data;
};

export async function getMyVouchers(id) {
  if (!id) throw new Error('Employee ID is needed to fetch all vouchers data');

  const response = await unwrap(await api.get(`/api/reimbursement-requests/${id}`));
  const raw = Array.isArray(response.data) ? response.data : [];

  const normalized = {
    pending: [],
    closed: [],
  };

  raw.forEach((voucher) => {
    const uiStatus = API_VOUCHER_STATUS_KEYS[voucher.status];
    const bucket = uiStatus === VOUCHER_STATUS_KEYS.PENDING ? 'pending' : 'closed';

    if (!uiStatus) return;

    normalized[bucket].push({
      id: voucher.id,
      employeeId: voucher.employee_id,
      employeeName: voucher.employee_name,
      department: voucher.department,
      dateOfEvent: voucher.date_of_event ? formatDate(voucher.date_of_event) : null,
      amountRequested: Number(voucher.amount_requested),
      amountReimbursed: Number(voucher.amount_reimbursed),
      expenseType: voucher.expense_type,
      employeeNote: voucher.comment,
      attachmentUrl: voucher.document?.url ?? null,
      appliedOn: voucher.applied_on ? formatDate(voucher.applied_on) : null,
      status: uiStatus,
      rejectionReason: voucher.reason_for_rejection ?? null,
    });
  });

  return normalized;
}

export async function requestVoucher(id, data) {
  if (!id || !data)
    throw new Error('Employee id and application form data is required to request a voucher');

  const payload = {
    employee_id: id,
    expense_type: data.expenseType,
    amount_requested: data.amountRequested,
    date_of_event: data.dateOfEvent ? formatDate(data.dateOfEvent, 'YYYY-MM-DD') : null,
    comment: data.employeeNote,
    document: await ensureFileId(data.attachment),
    status: 'Active',
  };

  await unwrap(await api.post('/api/reimbursement-request', payload));
}
